var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2292 15.7675C16.2292 15.6725 16.2421 15.1256 16.2444 14.4375C16.2464 13.8088 16.1912 13.2025 16.4914 12.6477C17.6162 10.4095 20.8462 10.6375 21.6442 12.9175C21.7824 13.2929 21.7908 13.888 21.7867 14.4375C21.7814 15.1397 21.7962 15.7675 21.7962 15.7675M16.3671 16.4348C14.6571 16.4348 13.8021 17.6698 13.6121 18.4298C13.4221 19.1898 13.4221 21.9448 13.5361 23.0848C13.9161 24.5098 14.8661 25.0988 15.7971 25.2888C16.6521 25.3648 20.2621 25.3363 21.3071 25.3363C22.8271 25.3648 23.9671 24.7948 24.4421 23.0848C24.5371 22.5148 24.6321 19.3798 24.3946 18.4298C23.8911 16.9098 22.6371 16.4348 21.6871 16.4348H16.3671ZM33.25 17.7067V13.1103C33.25 10.5136 33.25 9.21528 32.6102 8.36821C31.9703 7.52113 30.5237 7.10989 27.6303 6.28741C25.6535 5.72549 23.9109 5.0485 22.5186 4.43046C20.6204 3.58783 19.6713 3.1665 19 3.1665C18.3287 3.1665 17.3796 3.58783 15.4814 4.43046C14.0891 5.0485 12.3466 5.72547 10.3698 6.28741C7.47639 7.10989 6.02968 7.52113 5.38984 8.36821C4.75 9.21528 4.75 10.5136 4.75 13.1103V17.7067C4.75 26.6133 12.7661 31.957 16.7738 34.0722C17.7351 34.5795 18.2156 34.8332 19 34.8332C19.7844 34.8332 20.2649 34.5795 21.2262 34.0722C25.2339 31.957 33.25 26.6133 33.25 17.7067Z",
    stroke: "url(#paint0_linear_696_1991)",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_1991",
    x1: 10,
    y1: 1.5,
    x2: 30,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FF99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityPrivacy);
export default __webpack_public_path__ + "static/media/SecurityPrivacy.76b468508e4e4bda221b98d3a94d5bb8.svg";
export { ForwardRef as ReactComponent };